module.exports = __webpack_public_path__ + "img/late.4260d131.png";